export default "__VITE_ASSET__D0u9Rz7g__"